/*
 * File: input-password.ts
 * File Created: 2024-09-13 09:29:09
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-09-24 07:44:48
 * Modified By: Val Liu
 * -----
 */

import { Component } from "vue-property-decorator";
import ComponentInput from "../input-string/input-string";
import { PropInnateSync } from "@root/core/vue-props";

@Component
export default class InputPassword extends ComponentInput {
    /// private helpers
    // show password
    showEyePassword = false;
    doToggleShowEyePassword() {
        this.showEyePassword = !this.showEyePassword;
    }
}
